import { useEffect, useState } from 'react';

import { useMap } from '@vis.gl/react-google-maps';

import boundaryData from '@/assets/shapefile-geojson.json';

export function Boundary() {
  const map = useMap();
  const [boundaryPolygon, setBoundaryPolygon] = useState<google.maps.Polygon | null>(null);
  const [bigOverlay, setBigOverlay] = useState<google.maps.Polygon | null>(null);

  useEffect(() => {
    if (!map) return;

    if (boundaryPolygon) {
      boundaryPolygon.setMap(null);
    }
    if (bigOverlay) {
      bigOverlay.setMap(null);
    }

    const feature = boundaryData.features[0];
    if (!feature || feature.geometry.type !== 'Polygon') return;

    const boundaryHole = feature.geometry.coordinates[0]
      .map((coord: number[]) => ({ lat: coord[1], lng: coord[0] }))
      .reverse();

    const bigOverlayCoordinates = [
      { lat: 80, lng: -100 },
      { lat: 80, lng: 80 },
      { lat: 20, lng: 80 },
      { lat: 20, lng: -100 },
      { lat: 80, lng: -100 },
    ];

    const overlayPolygon = new google.maps.Polygon({
      paths: [bigOverlayCoordinates, boundaryHole],
      strokeColor: '#8F8F8F',
      strokeOpacity: 1,
      strokeWeight: 2,
      fillColor: '#8F8F8F',
      fillOpacity: 0.4,
      map,
      zIndex: 100,
    });

    setBigOverlay(overlayPolygon);

    const boundaryPath = feature.geometry.coordinates[0].map((coord: number[]) => ({
      lat: coord[1],
      lng: coord[0],
    }));

    const boundary = new google.maps.Polygon({
      paths: boundaryPath,
      strokeColor: '#56E8FF',
      strokeOpacity: 1,
      strokeWeight: 6,
      fillColor: 'transparent',
      fillOpacity: 0,
      map,
      zIndex: 500,
    });

    setBoundaryPolygon(boundary);

    return () => {
      boundary.setMap(null);
      overlayPolygon.setMap(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map]);

  return null;
}
